"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridCookieUtil = void 0;
const common_types_1 = require("@as-react/common-types");
const CookieUtil_1 = require("./CookieUtil");
class HybridCookieUtil {
    constructor(cookies = undefined) {
        this.cookies = cookies;
    }
    hasABCookieSet(cookieName) {
        var _a;
        let abCookie;
        if (typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.cookie)) {
            // client side
            abCookie = CookieUtil_1.CookieUtil.get(cookieName);
        }
        else if (this.cookies) {
            // server side
            abCookie = (_a = this.cookies) === null || _a === void 0 ? void 0 : _a[cookieName];
        }
        return abCookie ? abCookie.toUpperCase() === common_types_1.ABTestCookieValue.B : undefined;
    }
}
exports.HybridCookieUtil = HybridCookieUtil;
//# sourceMappingURL=HybridCookieUtil.js.map